/**
 * IBM Confidential OCO Source Materials IBM Business Platform: Cognos Analytics Home
 * (C) Copyright IBM Corp. 2020, 2023
 *
 * The source code for this program is not published or otherwise divested of
 * its trade secrets, irrespective of what has been deposited with the U.S.
 * Copyright Office
 */
requirejs.config({
	map: {
		'*': {
			'css/bacontentnav': 'ca-content/lib/@waca/bacontentnav/public/css/bacontentnav',

			'ca-content/legacy/services': 'bacontentnav/services',
			'ca-content/legacy/utils': 'bacontentnav/utils',
			'ca-content/legacy/ui': 'bacontentnav/ui',

			'ca-content/legacy/ui/PowerPlayPromptPickerView': 'ca-content/legacy/ui/PowerPlayPromptPickerView',
			'ca-content/legacy/ui/RenderCallback': 'ca-content/legacy/ui/RenderCallback',
			'ca-content/legacy/ui/templates': 'ca-content/legacy/ui/templates',
			'ca-content/legacy/utils/C10Utils': 'ca-content/legacy/utils/C10Utils',
			'ca-content/legacy/utils/Utils': 'ca-content/legacy/utils/Utils',

			'ca-content/legacy/common/ui/contentbar_components': 'bacontentnav/common/ui/contentbar_components',
			'ca-content/legacy/common/ContentSelectionDialogView': 'bacontentnav/common/ContentSelectionDialogView',
			'ca-content/legacy/utils/PolicyHelper': 'bacontentnav/utils/PolicyHelper',

			'ca-content/legacy/common/ui/EllipsisLabel': 'bacontentnav/common/ui/EllipsisLabel',
			'ca-content/legacy/common/ui/list_actions/AddFolderAction': 'bacontentnav/common/ui/list_actions/AddFolderAction',
			'ca-content/legacy/common/ui/list_actions/AddInlineAction': 'bacontentnav/common/ui/list_actions/AddInlineAction',
			'ca-content/legacy/common/ui/list_actions/DefaultAction': 'bacontentnav/common/ui/list_actions/DefaultAction',
			'ca-content/legacy/common/ui/list_actions/DeleteAction': 'bacontentnav/common/ui/list_actions/DeleteAction',
			'ca-content/legacy/common/ui/list_actions/ListAction': 'bacontentnav/common/ui/list_actions/ListAction',
			'ca-content/legacy/common/ui/list_actions/ManageContentAction': 'bacontentnav/common/ui/list_actions/ManageContentAction',
			'ca-content/legacy/common/ui/list_actions/MRURemoveAction': 'bacontentnav/common/ui/list_actions/MRURemoveAction',
			'ca-content/legacy/common/ui/list_actions/NavigateContainerAction': 'bacontentnav/common/ui/list_actions/NavigateContainerAction',
			'ca-content/legacy/common/ui/LanguagePickerView': 'bacontentnav/common/ui/LanguagePickerView',
			'ca-content/legacy/common/ui/Breadcrumbs': 'bacontentnav/common/ui/Breadcrumbs',
			'ca-content/legacy/common/ui/BreadcrumbDropDown': 'bacontentnav/common/ui/BreadcrumbDropDown',
			'ca-content/legacy/common/ui/ContentGenericDialog': 'bacontentnav/common/ui/ContentGenericDialog',
			'ca-content/legacy/common/ui/list_columns': 'bacontentnav/common/ui/list_columns',
			'ca-content/legacy/common/ContentListPageView': 'bacontentnav/common/ContentListPageView',
			'ca-content/legacy/common/BaseContentWideView': 'bacontentnav/common/BaseContentWideView',

			//migrated from ba-core-client to ba-content-nav
			'bi/commons/ui/content/dialog/OpenDialog': 'bacontentnav/ui/dialogs/OpenDialog',
			'bi/commons/ui/content/dialog/SaveAsDialog': 'bacontentnav/ui/dialogs/SaveAsDialog',
			'bi/commons/ui/content/views/openView': 'bacontentnav/ui/views/OpenView',
			'bi/commons/ui/content/views/SaveAsView': 'bacontentnav/ui/views/SaveAsView',
			'bi/commons/ui/widgets/FileSelector': 'bacontentnav/ui/widgets/FileSelector',

			// Glass (for performance increase)
			'bacontentnav/lib/@waca/baglass/js/baglass': 'baglass',
			'bacontentnav/lib/@waca/core-client': 'baglass/core-client',
		}
	},
	paths: {
		'ca-content': 'js/ca-content',
		'homeBridgeBundle': 'js/ca-content/homeBridgeBundle',
		'contentBridgeBundle': 'js/ca-content/contentBridgeBundle',
		'contentGlassBundle': 'js/ca-content/contentGlassBundle',
		'legacyContentBundle': 'js/ca-content/legacyContentBundle',
		'legacyFolderBundle': 'js/ca-content/legacyFolderBundle',
		'legacyPropertiesBundle': 'js/ca-content/legacyPropertiesBundle',
		'legacyVersionBundle': 'js/ca-content/legacyVersionBundle',
		'legacyPreferencesBundle': 'js/ca-content/legacyPreferencesBundle',
		'legacyListActionBundle': 'js/ca-content/legacyListActionBundle',
		'bacontentnav': 'js/ca-content/lib/@waca/bacontentnav/public/js/bacontentnav'
	},
	bundles: {

	}
});
